<template>
    <div>
        <div class="echart-place" v-loading="loading">
            <div ref="chart" class="radar-chart"></div>
        </div>

        <!-- 用户选择设备弹窗 -->
        <el-dialog width="600px" :visible="userSelectDeviceDialogVisible" :title="'选择数据(' + this.title + '湿度合格率雷达图)'"
            class="user-select-device-dialog">
            <div class="user-select-device-dialog-body">
                <el-tree :data="userSelectDeviceTreeData" node-key="id" :props="treeProps" :show-checkbox="false"
                    default-expand-all>
                    <span slot-scope="{ node, data }">
                        <el-checkbox v-if="node.isLeaf" v-model="userSelectDeviceCheckboxData[data.id]">
                            {{ node.label }}</el-checkbox>
                        <span v-else>{{ node.label }}</span>
                    </span></el-tree>
            </div>
            <div class="user-select-device-dialog-footer" slot="footer">
                <el-button @click="userSelectDeviceDialogClose">取消</el-button>
                <el-button type="primary" @click="userSelectDeviceDialogSubmit">确定</el-button>
            </div>
        </el-dialog>

        <!-- 用户选择设备齿轮按钮 -->
        <div class="user-select-device-button" v-if="allowUserSelectDevice">
            <el-button type="text" icon="el-icon-setting" @click="showUserSelectDeviceDialog"></el-button>
        </div>
    </div>
</template>
<script>
import { AverageArray } from "../tools/GeneralTool";

export default {
    name: 'TimeBlock',
    props: {
        daysCount: {
            type: Number,
            default: 7,
        },
        polygonNameDeviceIdListDict: {
            type: Object,
            default: {},
        },
        inputDeviceIdPassRateDict: {
            type: Object,
            default: undefined
        },
        initOnMount: {
            type: Boolean,
            default: true,
        },
        humidityPassLine: {
            type: Number,
            default: 60,
        },
        isEquivelant: {
            type: Boolean,
            default: false,
        },
        allowUserSelectDevice: {
            type: Boolean,
            default: false,
        },
        ignoreEmptyData: {
            type: Boolean,
            default: false,
        },
        title: String,
        titleSize: {
            type: Number,
            default: 12,
        },
        splitLine: String,
    },
    data() {
        return {
            loading: true,
            initComplete: false,
            polygonNamePassRateDict: {},
            userSelectDeviceIdDict: {},
            userSelectDeviceCheckboxData: {},
            userSelectDeviceTreeData: [],
            userSelectDeviceDialogVisible: false,
            chart: null,
            radarNameCountSwitchLineIndexDict: {
                3: [1, 2],
                4: [1, 3],
                5: [1, 2, 3, 4],
                6: [1, 2, 4, 5],
                8: [1, 2, 3, 5, 6, 7],
            },
            treeProps: {
                children: 'children',
                label: 'name'
            },
            resultIgnoreEmptyData: false,
        }
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
    },
    computed: {
        daysCountComputed() {
            if (this.daysCount >= 7) {
                return 7;
            }
            if (this.daysCount < 0) {
                return 0;
            }
            return this.daysCount;
        },
        isInputPassRateMode() {
            if (this.inputDeviceIdPassRateDict === undefined || this.inputDeviceIdPassRateDict === null) {
                return false;
            }

            return true;
        },
    },
    mounted() {
        this.chart = this.$echarts.init(this.$refs.chart);

        let treeData = [];
        for (let polygonName in this.polygonNameDeviceIdListDict) {
            let deviceIdList = this.polygonNameDeviceIdListDict[polygonName];
            let treeChildrenList = [];
            for (let deviceId of deviceIdList) {
                this.$set(this.userSelectDeviceIdDict, deviceId, true);
                treeChildrenList.push({
                    id: deviceId,
                    name: deviceId,
                })
            }
            treeData.push({
                id: polygonName,
                name: polygonName,
                children: treeChildrenList,
            })
        }
        this.userSelectDeviceTreeData = treeData;

        if (this.initOnMount) {
            this.GetDataAndUpdateChart();
        };
    },
    watch: {
        inputDeviceIdPassRateDict: {
            handler() {
                this.loading = true;

                this.$nextTick(() => {
                    this.GetDataAndUpdateChart();
                })

            },
            deep: true,
        },
    },
    methods: {
        GetDataAndUpdateChart() {
            this.loading = true;
            let humidityPercentageRequestList = [];
            let polygonNamePassRateListDict = {};
            let deviceIdPolygonNameDict = {};
            for (let polygonName in this.polygonNameDeviceIdListDict) {
                polygonNamePassRateListDict[polygonName] = [];
                let deviceIdList = this.polygonNameDeviceIdListDict[polygonName];
                for (let deviceId of deviceIdList) {
                    deviceIdPolygonNameDict[deviceId] = polygonName;

                    if (this.isInputPassRateMode) {
                        continue;
                    }

                    if (this.allowUserSelectDevice && this.userSelectDeviceIdDict[deviceId] !== true) {
                        continue;
                    }

                    humidityPercentageRequestList.push(this.createGetHttp_humidityPercentage(deviceId));
                }
            }

            if (this.isInputPassRateMode) {
                //input pass rate

                for (let resDeviceId in this.inputDeviceIdPassRateDict) {
                    let resPolygonName = deviceIdPolygonNameDict[resDeviceId];

                    if (!resPolygonName) {
                        continue;
                    }

                    if (this.allowUserSelectDevice && this.userSelectDeviceIdDict[resDeviceId] !== true) {
                        continue;
                    }

                    polygonNamePassRateListDict[resPolygonName].push(this.inputDeviceIdPassRateDict[resDeviceId]);
                }

                this.calculatePolygonPassRateAndInitChart(polygonNamePassRateListDict);
            }
            else {
                //get pass rate from api

                this.$http.all(humidityPercentageRequestList).then(
                    this.$http.spread((...resList) => {
                        let resultIgnoreEmptyData = false;
                        for (let resItem of resList) {
                            let resDeviceId = resItem.data.deviceId;
                            let resPolygonName = deviceIdPolygonNameDict[resDeviceId];
                            if (!resPolygonName) {
                                throw 'cannot find correct polygon name'
                            }

                            polygonNamePassRateListDict[resPolygonName].push(resItem.data.percentage_humidityBeforeLine.toFixed(2));

                            resultIgnoreEmptyData = resultIgnoreEmptyData || resItem.data.ignoreEmptyData;
                        }

                        this.resultIgnoreEmptyData = resultIgnoreEmptyData;
                        this.calculatePolygonPassRateAndInitChart(polygonNamePassRateListDict);
                    })
                )
            }

        },
        calculatePolygonPassRateAndInitChart(polygonNamePassRateListDict) {
            let polygonNameAvgPassRateDict = {};
            let emptyPassRatePolygonNameDict = {};
            for (let polygonName in this.polygonNameDeviceIdListDict) {
                let passRateList = polygonNamePassRateListDict[polygonName];

                // console.log(polygonName+": "+JSON.stringify(passRateList));

                let avgPassRate = 0;
                if (passRateList.length > 0) {
                    avgPassRate = AverageArray(passRateList).toFixed(1);
                }
                if (passRateList.length === 0) {
                    emptyPassRatePolygonNameDict[polygonName] = true;
                }

                polygonNameAvgPassRateDict[polygonName] = avgPassRate;
            }
            this.polygonNamePassRateDict = polygonNameAvgPassRateDict;
            this.$emit('setRadarData', polygonNameAvgPassRateDict);

            //update chart
            let chartName = "";
            if (this.title) {
                chartName = this.title;
            }
            let hoursCount = this.daysCountComputed * 24;
            chartName += hoursCount + "小时";
            
            if (this.ignoreEmptyData || this.resultIgnoreEmptyData) {
                chartName += "有效";
            }
            if (this.isEquivelant) {
                chartName += "当量湿度";
            }
            else {
                chartName += "湿度";
            }

            chartName += "合格率(<" + this.humidityPassLine + "%RH)";

            let userSelectDevicePolygonNameSuffix = {};
            if (this.allowUserSelectDevice) {
                for (let polygonName in this.polygonNameDeviceIdListDict) {
                    let deviceIdList = this.polygonNameDeviceIdListDict[polygonName];
                    let selectedCount = 0;
                    let totalCount = 0;
                    for (let deviceId of deviceIdList) {
                        totalCount += 1;
                        if (this.userSelectDeviceIdDict[deviceId] === true) {
                            selectedCount += 1;
                        }
                    }

                    if (totalCount === selectedCount) {
                        userSelectDevicePolygonNameSuffix[polygonName] = "";
                    } else {
                        userSelectDevicePolygonNameSuffix[polygonName] = "(" + selectedCount + "/" + totalCount + ")";
                    }
                }
            }

            let indicator = [];
            let passrateData = [];
            let switchLineIndex = this.radarNameCountSwitchLineIndexDict[Object.keys(this.polygonNamePassRateDict).length];
            let index = 0;
            for (let polygonName in this.polygonNamePassRateDict) {
                let passRate = this.polygonNamePassRateDict[polygonName];

                let polygonNameDisplay = polygonName;
                if (this.allowUserSelectDevice && userSelectDevicePolygonNameSuffix[polygonName]) {
                    polygonNameDisplay += userSelectDevicePolygonNameSuffix[polygonName];
                }

                let indicatorName = "";
                if (switchLineIndex && switchLineIndex.includes(index)) {
                    indicatorName = polygonNameDisplay + "\n(" + passRate + "%)";
                }
                else {
                    indicatorName = polygonNameDisplay + "(" + passRate + "%)";
                }

                if (this.isInputPassRateMode && emptyPassRatePolygonNameDict[polygonName]) {
                    if (switchLineIndex && switchLineIndex.includes(index)) {
                        indicatorName = polygonNameDisplay + "\n(计算中...)";
                    }
                    else {
                        indicatorName = polygonNameDisplay + "(计算中...)";
                    }
                }

                indicator.push({
                    name: indicatorName,
                    max: 100,
                });
                passrateData.push(passRate);

                index++;
            }

            let splitLineStyle = "#bbb";
            if (this.splitLine && this.splitLine === "dark") {
                splitLineStyle = "#7d86a8"
            }
            let option = {
                title: {
                    text: chartName,
                    left: 'center',
                    textStyle: {
                        fontSize: this.titleSize,
                    }
                },
                radar: {
                    shape: 'polygon',
                    indicator: indicator,
                    splitNumber: 3,
                    radius: "68%",
                    center: ["50%", "55%"],
                    name: {
                        textStyle: {
                            fontSize: 10,
                            fontWeight: 900,
                            color: "#2C3E50",
                            padding: -10,

                        }
                    },
                    splitArea: {
                        show: true,
                        areaStyle: {
                            color: "rgba(0,0,0,0)"
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: splitLineStyle,
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: splitLineStyle,
                        }
                    },
                },
                series: [{
                    name: '湿度合格率',
                    type: 'radar',
                    silent: true,
                    data: [
                        {
                            value: passrateData,
                            name: '湿度合格率',
                            areaStyle: {
                                color: "rgba(64, 75, 141, 0.7)"
                            },
                            lineStyle: {
                                width: 2,
                                color: '#2D4273'
                            }
                        },],
                }],
            };

            this.chart.setOption(option);

            if (!this.initComplete) {
                this.$emit('initComplete');
                this.initComplete = true;
            }

            setTimeout(() => {
                this.loading = false;
            }, 100);
        },
        createGetHttp_humidityPercentage(deviceId) {
            let firstLine = this.humidityPassLine
            let secondLine = firstLine + 10;

            return this.$http.get("/deviceData/HumidityPercentage?deviceId=" + deviceId + "&firstLine=" + firstLine + "&secondLine=" + secondLine
                + "&daysCount=" + this.daysCountComputed + "&ignoreEmptyData=" + this.ignoreEmptyData);
        },
        initChart() {
            if (this.initComplete) {
                return;
            }

            this.GetDataAndUpdateChart();
        },
        showUserSelectDeviceDialog() {
            this.userSelectDeviceCheckboxData = JSON.parse(JSON.stringify(this.userSelectDeviceIdDict));
            this.userSelectDeviceDialogVisible = true;
        },
        userSelectDeviceDialogSubmit() {
            this.userSelectDeviceIdDict = JSON.parse(JSON.stringify(this.userSelectDeviceCheckboxData));
            this.userSelectDeviceDialogVisible = false;
            this.GetDataAndUpdateChart();
        },
        userSelectDeviceDialogClose() {
            this.userSelectDeviceDialogVisible = false;
        },
    }
}
</script>
<style lang="scss" scoped>
.echart-place {
    // height: 350px;
    // width: 500px;
    height: 170px;
    width: 240px;
    color: #fff;
    font-size: 12px;
    background: rgba(255, 255, 255, 0.45);
    filter: opacity(30);
    text-align: center;
    z-index: 100;
    //   div {
    //     text-shadow: 1px 2px 2px #bdb8b8;
    //   }
    //   .time {
    //     padding: 5px;
    //     font-size: 40px;
    //     font-weight: 100;
    //   }
    //   .position {
    //     font-size: 17px;
    //   }

    .radar-chart {
        width: 100%;
        height: 100%;
    }
}

.user-select-device-button {
    position: absolute;
    top: -10px;
    right: 0px;

    & button {
        color: rgba(64, 75, 141, 0.7);
    }
}

.user-select-device-dialog-body {
    height: 400px;
    overflow: auto;
}
</style>